import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import SystemWideAlertSummary from '#/transit-tracker/components/SystemWideAlertSummary';
import * as Styled from './styled';

function SystemWideAlertSummaryList({
  systemWideAlerts,
  viewGlobalAlertsClick,
  className,
}) {
  const { alertBannerIsVisible } = useSelector(s => s.user);

  return alertBannerIsVisible ? (
    <Styled.AlertListWrapper className={className}>
      {systemWideAlerts.map(a => (
        <Styled.AlertRow key={a.id}>
          <SystemWideAlertSummary
            viewGlobalAlertsClick={viewGlobalAlertsClick}
            systemWideAlert={a}
          />
        </Styled.AlertRow>
      ))}
    </Styled.AlertListWrapper>
  ) : null;
}

SystemWideAlertSummaryList.propTypes = {
  /** Collection of system wide alerts to display */
  systemWideAlerts: PropTypes.arrayOf(PropTypes.shape({}).isRequired)
    .isRequired,
  /** Function fired when the AlertButton component within
   * SystemWideAlertSummary is clicked */
  viewGlobalAlertsClick: PropTypes.func,
  /** Identifies the element that is styled if used as a styled-component */
  className: PropTypes.string,
};

SystemWideAlertSummaryList.defaultProps = {
  viewGlobalAlertsClick: () => {},
  className: null,
};

export default SystemWideAlertSummaryList;
